import {Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy} from '@angular/core';
import { ICategoryTarget } from '../../irb-editors.model';
import { UtilityService } from '../../../irb-common/services/utility.service';
import { EditorModelService } from '../editor-model.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'irb-legacy-allocations-chart',
  templateUrl: './legacy-allocations-chart.component.html',
  styleUrls: ['./legacy-allocations-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class LegacyAllocationsChartComponent implements OnInit, OnDestroy {

  chartData: any;
  categoryTargetPercent: Array<ICategoryTarget> = [];
  colors: Array<string>;
  private editDataChangeSubscription: Subscription;
  objectOfCategoryLists: any = {};

  options: any = {
    responsive: true,
    maintainAspectRatio: false,
    rotation: Math.PI,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const decimal = this.modelType === 'Blended' ? 2 : 1;
            const label = context.label;
            const value = Number(context.dataset.data[context.dataIndex]).toFixed(decimal);
            return label + " " + value + "%";
          }
        }
      }
    }
  };

  @Input()
  modelType: string;

  @Input()
  categoryLabel: string = 'CustCat';

  constructor(
    private util: UtilityService,
    private editorModelService: EditorModelService
  ) {}

  ngOnInit(): void {
    this.update();

    this.editDataChangeSubscription = this.editorModelService.parametersChanged.subscribe(() => {
      this.colors = [];
      this.categoryTargetPercent = [];
      this.update();
    });
  }

  update() {
    this.colors = this.editorModelService.getChatColors();
    let categories = this.editorModelService.getCategories();
    let percentages = this.editorModelService.getPercentages();
    this.categoryTargetPercent = this.editorModelService.getCategoryTargetPercent();
    if (categories.length === 0) {
      this.colors = ['#93000F'];
      categories = ['Under-Allocated'];
      percentages = [100];
      this.categoryTargetPercent = [{ 'category': 'Under-Allocated', 'targetPercent': 100, colorCode: '#93000F'}];
      let lists: any = [];
      lists[0] = this.categoryTargetPercent;
      this.objectOfCategoryLists = {
        numOfLists: 1,
        lists: lists
      };
    } else {
      this.buildObjectOfCategoryLists();
    }
    this.chartData = {
      labels: categories,
      datasets: [
        {
          data: percentages,
          backgroundColor: this.colors,
          hoverBackgroundColor: this.colors,
          borderWidth: 2,
          hoverBorderColor: ["#FFFFFF"]
        }
      ]
    };

    const globSet: any = this.editorModelService.getGlobalSettings();
    if (globSet && globSet.securityCustAttrAbbr) {
      this.categoryLabel = globSet.securityCustAttrAbbr;
    }
  }

  private buildObjectOfCategoryLists() {
    const copyData = JSON.parse(JSON.stringify(this.categoryTargetPercent));
    copyData.sort((a: any, b: any) => (Number(a.targetPercent) < Number(b.targetPercent)) ? 1 : -1);
    const numOfLists = Math.ceil(copyData.length / 10);
    let listsOfAll: any = [],
        singleList: any = [],
        startIdx: number,
        endIdx: number;
    for (let i = 0; i < numOfLists; i++) {
      startIdx = i * 10;
      endIdx = i * 10 + 10;
      singleList = copyData.slice(startIdx, endIdx);
      listsOfAll[i] = singleList;
    }
    this.objectOfCategoryLists = {
      numOfLists: 1,
      lists: listsOfAll
    };
  }

  getColorByCategory(category: string) {
    return this.editorModelService.getColorByCategory(category);
  }

  ngOnDestroy(): void {
    if (this.editDataChangeSubscription) {
      this.editDataChangeSubscription.unsubscribe();
    }
  }
}
